import React from 'react'
import { Link } from 'react-static'
import { TweenMax, Power2 } from 'gsap'
import PropTypes from 'prop-types'

export default class HomeSlideshow extends React.Component {
  static propTypes = {
    slides: PropTypes.array.isRequired,
    numLoaded: PropTypes.number.isRequired,
    loadNextSlide: PropTypes.func.isRequired
  }

  state = { current: 0 }
  animating = false
  slideshow = null
  mounted = true

  componentDidMount () {
    const { loaderHidden } = this.props
    if (loaderHidden) {
      this.animating = true
      this.animate(0)
      this.showElems()
      this.imgStyleAll()
    }
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillReceiveProps(next) {
    const { loaderHidden, numLoaded, slides, loadNextSlide } = this.props

    if (next.loaderHidden && !this.animating) {
      this.animating = true
      this.animate(1000)
      this.showElems()
    }

    if (next.loaderHidden !== loaderHidden && !next.loaderHidden) {
      clearInterval(this.slideshow)
      this.setState({current: 0})
    }

    if (next.numLoaded !== numLoaded && numLoaded < slides.length) {
      loadNextSlide()
      this.imgStyle(numLoaded)
    }
  }

  componentWillUnmount () {
    clearInterval(() => this.slideshow)
    this.mounted = false
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const scrollPos = document.body.getBoundingClientRect().top
    if (-scrollPos < window.innerHeight) {
      TweenMax.to(this.wrapper, 0, { y: scrollPos * 0.4 })
    }
  }

  animate = delay => {
    setTimeout(() => {
      this.slideshow = setInterval(() => this.toggleSlideshow(), 3800)
    }, delay)
  }

  showElems = () => {
    TweenMax.staggerTo('.home-slideshow__selectors, .home-slideshow__title-overlay', 0.8, { autoAlpha: 1, ease: Power2.easeInOut }, 0.1)
  }

  toggleSlideshow = () => {
    if (!this.mounted) return

    let { current } = this.state
    const { slides } = this.props
    if (current >= slides.length - 1) {
      current = 0
    } else {
      current++
    }
    this.setState({ current })
  }

  slideOverride = i => {
    clearInterval(this.slideshow)
    this.setState({ current: i }, () => {
      this.slideshow = setInterval(() => this.toggleSlideshow(), 4500)
    })
  }

  imgStyle = (i) => {
    const { slides } = this.props
    const slide = document.querySelector(`.home-slide-${slides[i].sys.id}`)
    const src = slides[i].fields.file.url
    slide.style.cssText = `background: url(${src}) no-repeat center center; background-size: cover`
  }

  imgStyleAll = () => {
    const { slides } = this.props
    slides.map((slide, i) => this.imgStyle(i))
  }

  render () {
    const { current } = this.state
    const { slides, numLoaded } = this.props
    const currentSlide = 'home-slideshow__slide home-slideshow__slide-current'
    const otherSlide = 'home-slideshow__slide'
    const currentSelector = 'home-slideshow__selector home-slideshow__selector-current'
    const otherSelector = 'home-slideshow__selector'
    return (
      <div ref={el => this.wrapper = el} className="home-slideshow relative">
        { slides !== null
          && slides.map((slide, i) => (
            slide.fields !== undefined &&
            <div
              className={i === current ? `${currentSlide} home-slide-${slide.sys.id}` : `${otherSlide} home-slide-${slide.sys.id}`}
              key={slide.sys.id}
            />
          ))
        }
        <div className="home-slideshow__selectors">
          { slides !== null
              && slides.map((slide, i) => (
                <div onClick={() => this.slideOverride(i)} className={i === current ? currentSelector : otherSelector}key={i} />
              ))
          }
        </div>
        <div className="home-slideshow__title-overlay">
          <h2>Residential &amp; Commercial Roofing Experts</h2>
          <Link to="/contact">
            <button className="secondary-button">Contact Us</button>
          </Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/home-page/HomeSlideshow.js